<template>
  <form @reset="handleFormReset">
    <h2 class="sr-only">Filter</h2>
    <FilterFieldset name="location" label="Location">
      <FilterSelect
        filter="location"
        :options="allLocations"
        :selection="locations"
      />
    </FilterFieldset>
    <FilterFieldset name="season" label="Saison" :disabled="disableFilters">
      <FilterSelect
        filter="seasons"
        :options="allSeasons"
        :selection="false"
        :multi="true"
      />
    </FilterFieldset>
    <FilterFieldset name="district" label="Bezirk" :disabled="disableFilters">
      <FilterSelect
        filter="districts"
        :options="allDistricts"
        :selection="districts"
        :multi="true"
      />
    </FilterFieldset>
    <fieldset data-fieldset="actions">
      <legend><span>Aktionen</span></legend>
      <button type="reset" data-action="reset">
        <SvgIcon icon="reset" />
      </button>
      <button type="button" data-action="search">
        <SvgIcon icon="search" />
      </button>
    </fieldset>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import EventBus from '@/util/event-bus'

import FilterFieldset from '@/components/FilterFieldset'
import FilterSelect from '@/components/FilterSelect'
import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'FilterForm',
  components: { FilterFieldset, FilterSelect, SvgIcon },
  computed: {
    ...mapState(['filters']),
    ...mapGetters([
      'allSeasons',
      'seasons',
      'allDistricts',
      'districts',
      'allLocations',
      'locations',
      'productions',
      'isApplyingFormFilters'
    ]),
    disableFilters() {
      return !this.isApplyingFormFilters
    }
  },
  methods: {
    ...mapActions(['resetFilters']),
    handleFormReset() {
      this.resetFilters()
      this.resetScroll()
      EventBus.$emit('reset')
    },
    resetScroll() {
      window.scrollTo(0, 0)
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.resetScroll()
      }
    }
  }
}
</script>

<style scoped>
form {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: calc(2em + var(--page-padding));
  padding-bottom: var(--page-padding);
  user-select: none;
}
fieldset[data-fieldset='season'] {
  margin-top: 0.8em;
}
fieldset[data-fieldset='district'] {
  margin-top: 0.6em;
}
fieldset[data-fieldset='actions'] {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
  padding-top: var(--page-padding);
  legend span {
    display: none;
  }
  button {
    @mixin type-smaller;
    @mixin type-medium-lineheight;
    vertical-align: baseline;
  }
  button + button {
    margin-left: 0.8em;
  }
}
/deep/ svg.icon-reset {
  transform: translateY(-5%);
}
button[type='button'] {
  @mixin type-large;
  @mixin type-medium-lineheight;
  vertical-align: baseline;
  &:disabled {
    color: var(--color-highlight);
    cursor: default;
  }
}
button[data-action='search'] {
  display: none;
}
@mixin breakpoint-medium {
  form {
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: var(--page-padding);
  }
  /deep/ fieldset[data-fieldset='location'] {
    position: absolute;
    bottom: var(--page-padding);
    padding-right: var(--page-padding);
    left: 0;
    width: var(--content-width-aside);
    overflow: hidden;
  }
  fieldset[data-fieldset='season'],
  fieldset[data-fieldset='district'] {
    flex: 0 0 var(--content-width-main);
    margin-left: auto;
  }
  fieldset[data-fieldset='season'] {
    margin-top: 0;
  }
  fieldset[data-fieldset='actions'] {
    right: var(--content-width-main);
    padding-right: var(--page-padding);
    margin-top: -0.25em;
  }
}
@media only print {
  fieldset[data-fieldset='actions'] {
    display: none;
  }
}
</style>
